import React from 'react';
import { TopWrapper, TopBottomWrapper, TopActionsContainer } from '../ConfigPage.styled';
import { Button, Typography } from '@ann/web-components';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const ProfileImageSection = ({ imageUrl, onImageChange, agentName = 'Agent' }) => {
  const handleUploadImage = () => {
    // TODO: Implementar upload de imagen
    console.log('Upload image');
  };

  const handleGenerateImage = () => {
    // TODO: Implementar generación de imagen con AI
    console.log('Generate image');
  };

  return (
    <TopWrapper>
      <NameInitialsAvatar
        name={agentName}
        bgColor="#2563eb"
        textColor="#ffffff"
        size="50px"
        borderRadius="50%"
        textWeight="bold"
        textSize="18px"
        borderColor="#ffffff"
        borderStyle="solid"
        borderWidth="2px"
      />
      <TopBottomWrapper>
        <TopActionsContainer>
          <Button
            label="Upload Image"
            size="medium"
            type="secondary"
            onClick={handleUploadImage}
            disabled={true}
          />
          <Button
            label="Generate Image"
            size="medium"
            type="secondary"
            onClick={handleGenerateImage}
            disabled={true}
          />
        </TopActionsContainer>
        <Typography
          category="body"
          weight="regular"
          color="body"
          size="medium"
        >
          Add a profile image PNG or JPG, max 2MB
        </Typography>
      </TopBottomWrapper>
    </TopWrapper>
  );
};

export default ProfileImageSection;

